import React from "react";
import { Grid, Stack, Tooltip } from "@mui/material";

import {
  createAvtarName,
  fixedDigitsAfterDecimal,
  hasImage,
} from "../../../../utils";
import Avatar from "../../../../components/Avatar/index";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";

export const ByTaskAvatar = ({
  card = [],
  openBoard,
  handleOpenCardDetail,
}) => {
  const [data, updateSearchParams] = useCustomSearchParams("card_id");

  return (
    <Grid
      item
      xs={12}
      md={9}
      sx={{
        paddingLeft: "0px !important",
        paddingRight: "0px !important",
      }}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={1}
          width={"100%"}>
          <Avatar
            username={`${card[0]?.cardlog?.user?.first_name} ${card[0]?.cardlog?.user?.last_name}`}
            user_image={card[0]?.cardlog?.user?.user_image}
            title={`${card[0]?.cardlog?.user?.first_name} ${card[0]?.cardlog?.user?.last_name}`}
            className="user-avtar-dropdown user-avatar mr-8"
            style={
              !hasImage(card[0]?.cardlog?.user?.user_image) && {
                bgcolor: card[0]?.cardlog?.user?.profile_color?.background,
                color: card[0]?.cardlog?.user?.profile_color?.text,
              }
            }>
            {createAvtarName(
              `${card[0]?.cardlog?.user?.first_name} ${card[0]?.cardlog?.user?.last_name}` ||
                ""
            )}
          </Avatar>
          <Stack direction={"column"} width={"100%"}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              spacing={1}>
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <div className="d-flex align-items-center primary_underline">
                  <Tooltip title={card[0]?.board_name}>
                    <a
                      className="board-anquor cursor-pointer"
                      onClick={openBoard}>
                      {`${card[0]?.key}`.toUpperCase()}
                    </a>
                  </Tooltip>
                  -
                  <a
                    className="board-anquor cursor-pointer"
                    onClick={() => {
                      updateSearchParams(
                        "card_id",
                        card[0]?.cardlog?.card?.card_id
                      );
                    }}>
                    {card[0]?.cardlog?.card?.card_id}:
                  </a>
                </div>
                {card[0].epic_name && (
                  <div className="card-epic-tag mr-1">
                    <p className="card-epic-tag-text">{card[0]?.epic_name}</p>
                  </div>
                )}
              </Stack>
              <p className="worklog-status">{card[0]?.workflow_step_name}</p>
            </Stack>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              flexWrap={"wrap"}
              className="mt-1">
              <p className="worklog-title mr-2">
                {card[0]?.cardlog?.card?.title}
              </p>
              <p className="hours">
                {fixedDigitsAfterDecimal(card[0]?.cardlog?.hours_spent)} Hour
              </p>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Grid>
  );
};
